import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { MijnKanaalconfiguratieService, ChannelName } from '@ap/mijn-kanaalconfiguratie';

import { CONVERSATIONAL_CONFIGURATION_DEFAULT, CONVERSATIONAL_ENVIRONMENT } from '../../klant-conversational-connector.constants';
import { SeamlyConfiguration } from '../../klant-conversational-connector.model';

@Injectable({
    providedIn: 'root'
})
export class BasePathService {
    private readonly mijnKanaalconfiguratieService = inject(MijnKanaalconfiguratieService);

    private basePath: string;
    private isLoadedCorrectly = false;

    public async init(): Promise<void> {
        const configuration = await firstValueFrom(
            this.mijnKanaalconfiguratieService.getJSONConfiguration<SeamlyConfiguration>(
                ChannelName.MIJN_KLANT,
                CONVERSATIONAL_ENVIRONMENT,
                CONVERSATIONAL_CONFIGURATION_DEFAULT,
                false
            )
        );
        if (configuration.seamlyApiDomain) {
            const prefix = configuration.environment === 'DEV' ? '/services/' : 'https://';
            this.basePath = prefix.concat(configuration.seamlyApiDomain);
            this.isLoadedCorrectly = true;
        }
    }

    public getBasePath(): string {
        return this.basePath;
    }

    public getIsLoadedCorrectly(): boolean {
        return this.isLoadedCorrectly;
    }
}
